/**
 * Single source of truth for Basis vs Premium.
 * guest | basis | premium cell values: ✓, ✗, or a short qualifier.
 *
 * Not part of the product: saved lists, report alerts, fit-score recommendations.
 */

export const BASIS_COMPARE_LIMIT = 2;
export const PREMIUM_COMPARE_LIMIT = 5;

export const PRICING_FEATURE_ROWS = [
  {
    id: 'browse',
    label: 'Institutioner, seneste scorer og PDF',
    guest: '✓',
    basis: '✓',
    premium: '✓',
  },
  {
    id: 'compare',
    label: 'Sammenligning',
    guest: '✗',
    basis: '✓ (2, kun scorer)',
    premium: '✓ (op til 5)',
  },
  {
    id: 'decision',
    label: 'Hvilken institution står stærkest, og hvorfor',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'historical_trends',
    label: 'Historiske tilsyn',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'all_reports',
    label: 'Ældre tilsynsrapporter',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'related_institutions',
    label: 'Naboer i bydelen',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'map',
    label: 'Kortvisning',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'summary',
    label: 'AI-resumé af tilsynsrapport',
    guest: '✗',
    basis: '✓ (uddrag)',
    premium: '✓ (fuldt)',
  },
  {
    id: 'qa',
    label: 'Spørg rapporten',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
  {
    id: 'compare_export',
    label: 'Eksporter sammenligning',
    guest: '✗',
    basis: '✗',
    premium: '✓',
  },
];

function qualifierText(cell) {
  return String(cell).replace('✓', '').trim();
}

export function basisPlanFeatures() {
  return PRICING_FEATURE_ROWS.map((row) => {
    if (row.basis === '✗') return { text: row.label, included: false };
    const qualifier = qualifierText(row.basis);
    return {
      text: qualifier ? `${row.label} ${qualifier}` : row.label,
      included: true,
    };
  });
}

export function premiumPlanFeatures() {
  const extras = PRICING_FEATURE_ROWS
    .filter((row) => row.premium !== row.basis && row.premium !== '✗')
    .map((row) => {
      const qualifier = qualifierText(row.premium);
      return qualifier ? `${row.label} ${qualifier}` : row.label;
    });
  return ['Alt i Basis', ...extras];
}

export const FEATURE_UPSELL_LABELS = {
  map: 'Kort over institutioner i nærområdet',
  compare: 'Den fulde sammenligning: observationer, historik og forskellen',
  compare_export: 'Eksport af sammenligningen',
  related_institutions: 'Hvordan institutionen klarer sig ift. naboerne',
  historical_trends: 'Om kvaliteten har holdt over flere tilsyn',
  all_reports: 'Ældre tilsynsrapporter',
  summary: 'Det fulde AI-resumé',
  qa: 'Spørgsmål til rapporten, når du skal vælge',
  decision: 'Hvilken institution der står stærkest, og hvorfor',
};
